import { useCallback, useRef, useState } from "react";
import { Animated, Platform } from "react-native";

export function useLongPress({
  dotSize,
  duration,
  layout,
  onLongPress,
}: {
  dotSize: number;
  duration: number;
  layout?: any;
  onLongPress?: any;
}) {
  const longPressScale = useRef(new Animated.Value(2)).current;
  const [longPressFinished, setLongPressFinished] = useState(false);

  const onLongPressFn = useCallback(() => {
    if (onLongPress) {
      Animated.timing(longPressScale, {
        toValue: 1 * ((layout?.width ?? 200) / dotSize) + 2,
        duration,
        useNativeDriver: Platform.OS !== "web",
      }).start(({ finished }) => {
        if (finished) {
          setLongPressFinished(true);
          if (onLongPress) {
            setTimeout(() => {
              onLongPress();
              Animated.timing(longPressScale, {
                toValue: 0,
                duration: 0,
                useNativeDriver: Platform.OS !== "web",
              }).start();
            }, 100);
          }
        }
      });
    }
  }, [
    dotSize,
    duration,
    layout?.width,
    onLongPress,
    longPressScale,
    setLongPressFinished,
  ]);

  const onPressOut = useCallback(() => {
    setLongPressFinished(false);
    Animated.timing(longPressScale, {
      toValue: dotSize,
      duration: duration / 3,
      useNativeDriver: Platform.OS !== "web",
    }).start();
  }, [dotSize, duration, longPressScale, setLongPressFinished]);

  return {
    longPressProps: {
      dotSize,
      scale: longPressScale,
    },
    pressableProps: onLongPress
      ? {
          onLongPress: onLongPressFn,
          onPressOut,
        }
      : undefined,
    longPressFinished,
    setLongPressFinished,
  };
}
